import React from 'react';
import { DateFromTo, GrossIncomeByPaymentMethodComponent } from '../../../../generated/graphql';
import { useFromToContext } from '../../../shared';
import { Placeholder } from '../Placeholder';
import { CHART_PLACEHOLDER_HEIGHT } from '../constants';
import TotalIncomeView from './TotalIncomeView';

const TotalIncome = () => {
    const { dateFromTo } = useFromToContext();
    return (
        <GrossIncomeByPaymentMethodComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={CHART_PLACEHOLDER_HEIGHT} />}
        >
            {({ data: { grossIncomeByPaymentMethod } }) => (
                <TotalIncomeView
                    grossIncomeByPaymentMethod={grossIncomeByPaymentMethod}
                />
            )}
        </GrossIncomeByPaymentMethodComponent>
    );
};

export default TotalIncome;